module.exports = __webpack_public_path__ + "media/images/logo-fce06ff7a2815cdc66e047c517f2fafa.png";